<template>
  <v-app>
    <AppNav />
    <v-main>
      <router-view />
    </v-main>
  </v-app>
</template>
<script>
import AppNav from "@/components/AppNav.vue"

export default {
  components: {
    AppNav,
  },
  data() {
    return {
    }
  },
}
</script>
